{
  "EntityHoverCard": {
    "cantLoad": "Can’t load the details.",
    "openInSidebar": "Open in sidebar",
    "openFullPage": "Open full page",
    "more": "+{{count}} more"
  },
  "ConfirmPopover": {
    "cancel": "Cancel"
  },
  "RowList": {
    "reorderInstructions": "To reorder, press Space or Enter to pick up this {{item}}, use the up and down arrow keys to move it, then press Space or Enter to drop it, or Escape to cancel.",
    "pickedUp": "Picked up {{item}} {{position}} of {{count}}.",
    "notOver": "Not over a position in the list.",
    "moving": "Moving to position {{position}} of {{count}}.",
    "droppedUnchanged": "Dropped. The order did not change.",
    "dropped": "Dropped at position {{position}} of {{count}}.",
    "cancelled": "Cancelled. {{item}} stays at position {{position}} of {{count}}.",
    "reorder": "Reorder {{label}}",
    "remove": "Remove {{label}}"
  },
  "GlobalCustomFieldHint": {
    "ariaLabel": "Global field",
    "tooltip": "This field is global. Changes are visible in all workspaces this resource is assigned to."
  },
  "FormSaveButton": {
    "save": "Save"
  },
  "StickyFormActionsBar": {
    "toolbarLabel": "Form actions",
    "hotkeyHintBefore": "Press",
    "hotkeyHintAfter": "to save changes",
    "cancel": "Cancel"
  },
  "DialogErrorFooter": {
    "error": "Error"
  },
  "FormDialogContent": {
    "save": "Save"
  },
  "EntityCreateDialog": {
    "back": "Back",
    "next": "Next",
    "unsavedChanges": "You have unsaved changes!"
  },
  "ArchiveConfirmationDialog": {
    "archiveTitle": "Archive {{entityName}}?",
    "unarchiveTitle": "Unarchive {{entityName}}?",
    "archiveDescription": "Are you sure you want to archive this {{entityName}}? You will not lose any data.",
    "unarchiveDescription": "Are you sure you want to unarchive this {{entityName}}?",
    "archiveConfirm": "Archive",
    "unarchiveConfirm": "Unarchive",
    "cancel": "Cancel",
    "confirmInProgress": "{{label}}…",
    "confirmRetry": "{{label}} (Retry)",
    "srDescriptionArchive": "Confirmation modal for archiving a {{entityName}}.",
    "srDescriptionUnarchive": "Confirmation modal for unarchiving a {{entityName}}."
  },
  "CurrencyCombobox": {
    "placeholder": "Search currencies…",
    "empty": "No matching currencies"
  },
  "TimezoneCombobox": {
    "placeholder": "Search timezones…",
    "empty": "No matching timezones"
  },
  "ImageUploadField": {
    "hint": "Drop an image here or click the tile.",
    "formats": "JPG or PNG, up to 10 MB",
    "upload": "Upload",
    "change": "Change",
    "uploading": "Uploading…",
    "paste": "Paste",
    "remove": "Remove",
    "uploadError": "Failed to upload the picture",
    "pasteEmpty": "There is no image in the clipboard",
    "pasteFailed": "Couldn't read the clipboard. Focus the tile and press the paste shortcut instead."
  },
  "ImageCollectionUploadField": {
    "listLabel": "Uploaded files",
    "emptyTitle": "Drag files here, or click to browse",
    "emptyTitleSingle": "Drag a file here, or click to browse",
    "formats": "{{formats}}, up to {{size}} · paste with ⌘V while the field has focus",
    "formatImages": "images",
    "formatVideos": "videos",
    "formatPdf": "PDF documents",
    "add": "Add",
    "browse": "Browse files",
    "replace": "Replace",
    "paste": "Paste",
    "reorderHint": "{{count}} files · drag to reorder",
    "dropToAdd": "Drop to add",
    "reorder": "Reorder {{name}}",
    "remove": "Remove {{name}}",
    "uploadFailed": "Upload failed",
    "retry": "Retry",
    "dismiss": "Dismiss {{name}}",
    "rejected": "{{name}} can't be uploaded here",
    "tooLarge": "{{name}} is larger than {{size}}",
    "pasteEmpty": "There is no image in the clipboard",
    "pasteFailed": "Couldn't read the clipboard. Focus the field and press the paste shortcut instead.",
    "open": "Open file",
    "removeShort": "Remove",
    "noFiles": "No files yet"
  },
  "FinancialDocumentDialog": {
    "addInvoice": "Add invoice",
    "addReceipt": "Add receipt",
    "editInvoice": "Edit invoice",
    "editReceipt": "Edit receipt",
    "create": "Create",
    "invoice": "Invoice",
    "invoices": "Invoices",
    "receipt": "Receipt",
    "receipts": "Receipts",
    "expense": "Expense",
    "expensePlaceholder": "Select expense",
    "reference": "Reference",
    "referencePlaceholder": "Enter reference",
    "amount": "Amount",
    "status": "Status",
    "statusPlaceholder": "Select status",
    "file": "File",
    "fileDescription": "PDF and image formats supported",
    "upload": "Upload",
    "attachedReceipt": "Attached receipt",
    "documentCount": "{{count}} document",
    "documentCount_other": "{{count}} documents",
    "unsavedChanges": "You have unsaved changes in the financial document form.",
    "download": "Download",
    "openInNewTab": "Open in new tab",
    "untitled": "Untitled",
    "noFileAttached": "No file attached",
    "documentSaved": "Document saved",
    "documentDeleted": "Document deleted",
    "documentSaveFailed": "Failed to save document",
    "documentDeleteFailed": "Failed to delete document",
    "allReconciledTooltip": "All documents reconciled: actual equals committed, and every document (excluding those awaiting approval) has status Paid or Approved.",
    "underCommittedTooltip": "Under committed: actual spend is less than the committed amount.",
    "overCommittedTooltip": "Over committed: actual spend exceeds the committed amount."
  },
  "UnsavedChangesDialog": {
    "title": "Unsaved Changes",
    "description": "You have unsaved changes. Are you sure you want to leave? Your changes will be lost.",
    "cancel": "Keep Editing",
    "confirm": "Discard Changes",
    "beforeUnload": "You have unsaved changes. Are you sure you want to leave?",
    "draftDescription": "Your changes to “{{title}}” have not been saved and will be lost."
  },
  "EnumFilterWidget": {
    "operator": {
      "matchAny": "is any of",
      "matchAll": "is all of",
      "matchNone": "is none of",
      "empty": "is empty",
      "notEmpty": "is not empty"
    },
    "searchPlaceholder": "Search for a value",
    "emptyValue": "Select",
    "valueNotRequired": "No values required"
  },
  "DateFilterCustomDialog": {
    "title": "Custom date or timeframe",
    "enterHumanDate": "Enter human date",
    "humanPlaceholder": "e.g. next 7 days, tomorrow, 2025-01-14, Jan 20 - Jan 27",
    "examples": "Examples: “next 7 days”, “tomorrow”, “Jan 20 - Jan 27”",
    "or": "or",
    "setSpecificDate": "Set specific date",
    "single": "Single",
    "range": "Range",
    "clear": "Clear",
    "willApply": "Will apply:",
    "apply": "Apply"
  },
  "DateFilterWidget": {
    "operator": {
      "between": "between",
      "after": "after",
      "before": "before",
      "equal": "on"
    },
    "emptyValue": "Set dates",
    "apply": "Apply",
    "cancel": "Cancel"
  },
  "BooleanFilterWidget": {
    "operator": {
      "is": "is",
      "isNot": "is not"
    }
  },
  "NumberFilterWidget": {
    "title": "Set number",
    "operator": {
      "equal": "is",
      "notEqual": "is not",
      "greaterThan": "greater than",
      "lessThan": "less than",
      "between": "between"
    },
    "to": "to",
    "apply": "Apply",
    "cancel": "Cancel"
  },
  "StringFilterWidget": {
    "operator": {
      "equals": "is",
      "contains": "contains",
      "notContains": "does not contain"
    },
    "placeholder": "Enter value",
    "emptyValue": "Set value",
    "apply": "Apply",
    "cancel": "Cancel",
    "suggestionsIdleHint": "Start typing to search, or choose a recent place below.",
    "suggestionsEmpty": "No matching places. Try a different search.",
    "recentPlacesHeading": "Recent",
    "useTypedText": "Use \"{{query}}\""
  },
  "FilterWidgetAddControl": {
    "manageFilters": "Manage filters",
    "searchPlaceholder": "Search filters…",
    "emptySearch": "No filters match your search"
  },
  "ArchivedTabs": {
    "all": "All",
    "archived": "Archived"
  },
  "ActiveTabs": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "SortableEntityTable": {
    "failedToLoadData": "Failed to load data",
    "selectAllItems": "Select all items",
    "selectItem": "Select {{key}}",
    "actionsSrOnly": "Actions",
    "validationIssueSrOnly": "Validation issue",
    "collapseRow": "Collapse row",
    "expandRow": "Expand row",
    "expandAllRows": "Expand all rows",
    "collapseAllRows": "Collapse all rows",
    "dragToReorder": "Reorder row",
    "locked": "Locked",
    "reorderSrOnly": "Reorder",
    "clearSortToReorder": "Clear sorting to reorder"
  },
  "MediaCarousel": {
    "openMedia": "Open media"
  },
  "PinViewer": {
    "empty": "No pins to show",
    "untitled": "Untitled pin",
    "listLabel": "Pins"
  },
  "MediaLoadStateOverlays": {
    "imageUnavailable": "Image unavailable",
    "videoUnavailable": "Video unavailable"
  },
  "EntityListToolbar": {
    "searchPlaceholder": "Search...",
    "resourcesSearchPlaceholder": "Search resources...",
    "calloutsSearchPlaceholder": "Search callouts...",
    "clearAllFilters": "Clear all filters"
  },
  "EntityGridItem": {
    "noName": "No name"
  },
  "CoreFields": {
    "status": "Status",
    "production_date": "Production Date",
    "code": "Code",
    "archived": "Archived",
    "userId": "Owner",
    "productionTypeId": "Production Type",
    "resource_type_id": "Type",
    "organisation_id": "Organization",
    "represented_by_id": "Agent",
    "role": "Role",
    "tags": "Tags",
    "groups": "Groups",
    "emails": "Emails",
    "phone_numbers": "Phones",
    "websites": "Websites",
    "socials": "Social Media",
    "locations": "Locations",
    "icon": "Icon",
    "color": "Color",
    "title": "Title",
    "description": "Description",
    "budget_amount": "Budget Amount",
    "createdAt": "Created",
    "updatedAt": "Updated"
  },
  "CalloutSpecificFields": {
    "published": "Published",
    "archived": "Archived",
    "slug": "URL slug"
  },
  "ResourceSpecificFields": {
    "groupName": "Resource Specific",
    "contact_type": "Resource Type",
    "emails": "Emails",
    "phones": "Phones",
    "websites": "Websites",
    "socials": "Social Media",
    "user_id": "Owner",
    "enterprise_workspaces": "Workspace",
    "enterprise_workspaces_workspaces": "Workspaces",
    "enterprise_workspaces_hidden": "Hidden",
    "enterprise_workspaces_global": "Global"
  },
  "ContactTypes": {
    "INDIVIDUAL": "Individual",
    "ORGANIZATION": "Organization",
    "LOCATION": "Location",
    "ITEM": "Item",
    "TALENT": "Talent",
    "AGENT": "Agent"
  },
  "CustomFields": {
    "today": "Today"
  },
  "EntityTypes": {
    "production": "Production",
    "booking": "Booking",
    "resource": "Resource",
    "expense": "Expense"
  },
  "FilterGroups": {
    "coreFields": "Core Fields",
    "customFields": "Custom Fields"
  },
  "ReconciliationsTable": {
    "collapseAllDocuments": "Collapse all documents",
    "expandAllDocuments": "Expand all documents",
    "lineType": "Line type",
    "updatedAt": "Updated",
    "vendorTooltipBooking": "Booking",
    "vendorTooltipBudgetExpense": "Production budget expense",
    "expenseDetailsPopover": {
      "title": "Expense details",
      "vendor": "Vendor",
      "category": "Category",
      "committed": "Committed",
      "actual": "Actual",
      "receipts": "Receipts",
      "edit": "Edit"
    }
  },
  "ReconciliationFilters": {
    "invoice_status": {
      "AWAITING_APPROVAL": "Awaiting approval",
      "APPROVED": "Approved",
      "PAID": "Paid",
      "DECLINED": "Declined"
    }
  },
  "EntityListViewSwitch": {
    "gridView": "Grid view",
    "listView": "List view"
  },
  "EntityListSortSelect": {
    "sort": "Sort",
    "placeholder": "Sort",
    "noSort": "No sort",
    "sortAsc": "(A→Z)",
    "sortDesc": "(Z→A)"
  },
  "EntityGridSelectionToolbar": {
    "selectAllItems": "Select all items"
  },
  "EntityGridListItem": {
    "selectItem": "Select {{key}}",
    "deselectItem": "Deselect {{key}}"
  },
  "EntityListRow": {
    "validationFailed": "Invalid data",
    "validationDetailsTitle": "Validation error details",
    "tryDisplayAnyway": "Display anyway",
    "hideUnsafePreview": "Hide preview",
    "renderCrashed": "Could not render this item",
    "renderTryAgain": "Try again"
  },
  "EntityGridTileSizeSlider": {
    "size": "Size",
    "thumbnailSizeAria": "Thumbnail size"
  },
  "SortableEntityGrid": {
    "itemsAriaLabel": "Items"
  },
  "EntityEmptyState": {
    "nothingHereYet": "Nothing here yet.",
    "noResultsMatchFilters": "No results match your current filters.",
    "clearFilters": "Clear filters",
    "pageOutOfRangeTitle": "This page does not exist",
    "pageOutOfRangeMessage": "You are on a page that has no results. Go back to the last available page.",
    "goToLastPage": "Go to last page"
  },
  "TableColumnManagerPopover": {
    "title": "Customize columns",
    "shown": "Shown",
    "available": "Available",
    "searchPlaceholder": "Search fields...",
    "reset": "Reset",
    "apply": "Apply",
    "cancel": "Cancel",
    "fixed": "Fixed",
    "noShownResults": "No matching visible fields",
    "noAvailableResults": "No matching available fields",
    "triggerAriaLabel": "Manage columns",
    "availableFieldsCount": "{{count}} field",
    "availableFieldsCount_other": "{{count}} fields",
    "dragHandle": "Drag {{field}}",
    "changed": "Changed",
    "showField": "Show {{field}}",
    "hideField": "Hide {{field}}"
  },
  "TransferToWorkspaceDialog": {
    "fieldCurrentWorkspace": "Current workspace",
    "selectWorkspace": "Select workspace",
    "sameWorkspace": "Choose a different workspace than the current one",
    "save": "Transfer",
    "transferFailed": "Transfer failed. Please try again."
  },
  "TransferToTeamDialog": {
    "fieldCurrentWorkspace": "Current workspace",
    "selectWorkspace": "Select workspace",
    "selectTeam": "Select team",
    "save": "Transfer",
    "transferFailed": "Transfer failed. Please try again."
  },
  "CustomFieldAddFlow": {
    "addTitle": "Add custom field",
    "createTitle": "Create new field",
    "searchPlaceholder": "Search fields or type to create…",
    "createNamed": "Create “{{name}}”",
    "addAsNewHint": "Add as a new custom field",
    "selectFieldsToAdd": "Select fields to add",
    "fieldsSection": "Fields",
    "groupsSection": "Field groups",
    "groupFieldCount_one": "{{count}} field",
    "groupFieldCount_other": "{{count}} fields",
    "groupMultiple": "Multiple",
    "alreadyAdded": "Already added",
    "currentlyAssigned": "Currently assigned ({{count}})",
    "noCatalog": "No custom fields are available yet. Create one below.",
    "noFieldsAvailable": "No fields available",
    "noFieldsAvailable_search": "No fields match your search",
    "saveFields": "Save Fields",
    "cancel": "Cancel",
    "createAndAssign": "Create & assign",
    "stageDescription_search": "Search existing custom fields or create a new one.",
    "stageDescription_create": "Configure the new custom field.",
    "back": "Back",
    "nameValidation_required": "Name is required.",
    "nameValidation_minLength": "Name must contain at least 3 characters.",
    "nameValidation_duplicate": "A custom field with this name already exists."
  },
  "IconPicker": {
    "placeholder": "Pick an icon"
  },
  "ColorPicker": {
    "placeholder": "Pick a color",
    "hexInputLabel": "Hex color",
    "hexInputPlaceholder": "#000000"
  },
  "ColorIconPicker": {
    "placeholder": "Pick icon and color"
  },
  "ResourceTypeIconPicker": {
    "placeholder": "Choose icon"
  },
  "FullPageErrorLog": {
    "copy": "Copy",
    "copied": "Copied"
  },
  "common": {},
  "SchemaForm": {
    "contact": {
      "row": {
        "EMAIL": "Email {{index}}",
        "PHONE": "Phone number {{index}}",
        "SOCIAL": "Social profile {{index}}",
        "WEBSITE": "Website {{index}}"
      },
      "add": {
        "EMAIL": "Add email",
        "PHONE": "Add phone number",
        "SOCIAL": "Add social profile",
        "WEBSITE": "Add website"
      },
      "placeholder": {
        "EMAIL": "Email address",
        "PHONE": "Phone number",
        "SOCIAL": "Social media handle",
        "WEBSITE": "Website URL"
      },
      "looksLike": {
        "EMAIL": "Looks like {{count}} emails.",
        "PHONE": "Looks like {{count}} phone numbers.",
        "SOCIAL": "Looks like {{count}} social profiles.",
        "WEBSITE": "Looks like {{count}} websites."
      },
      "error": {
        "platformRequired": "Choose the platform, or paste the profile link.",
        "notAnEmail": "This doesn’t look like an email address.",
        "notAWebsite": "This doesn’t look like a web address.",
        "valueRequired": "Type a value, or remove the row."
      },
      "hint": {
        "phoneUnreadable": "Can’t check this number. It will be saved as typed.",
        "phoneIncomplete": "This looks short or long for a +{{code}} number. It will be saved as typed.",
        "phoneTrunkZero": "After the country code, the leading 0 is dropped.",
        "duplicate": "Same as row {{row}}."
      },
      "pasted": "Pasted with the dial code added.",
      "keepAsPasted": "Keep as pasted: {{value}}",
      "splitInto_one": "Split into {{count}} row",
      "splitInto_other": "Split into {{count}} rows",
      "use": "Use {{fix}}",
      "goOn": "to go on",
      "primary": "Primary",
      "countryFor": "Country for {{row}}",
      "platformFor": "Platform for {{row}}",
      "labelFor": "Label for {{row}}",
      "label": "Label",
      "remove": "Remove {{what}}"
    },
    "location": {
      "placeholder": "Type or search a location"
    },
    "reference": {
      "select": "Select a {{noun}}",
      "search": "Search for a {{noun}}"
    },
    "list": {
      "manage": "Manage {{title}}",
      "remove": "Remove",
      "removeQuestion": "Remove {{item}}?",
      "newItem": "New {{item}}",
      "copy": "Copy {{text}}",
      "moveUp": "Move {{label}} up",
      "moveDown": "Move {{label}} down",
      "moved": "Moved to position {{position}} of {{count}}.",
      "putBack": "Put back at position {{position}} of {{count}}.",
      "pickedUp": "Picked up {{label}}. Up and down arrows move it, Space puts it down, Escape puts it back.",
      "removed": "Removed {{label}}."
    },
    "unit": {
      "overriddenIn": "Overridden in {{workspaces}}",
      "inheritFromGlobal": "Inherit from global",
      "inheritLabel": "Inherit {{title}} from global",
      "inheritFailed": "Failed to inherit from global",
      "inherited": "Inherited from Global",
      "overridden": "Overridden here",
      "cancelEditing": "Cancel editing {{title}}",
      "readOnly": "{{title}} is read-only",
      "edit": "Edit {{title}}",
      "noValue": "no value"
    },
    "validation": {
      "required": "{{label}} is required",
      "notANumber": "{{label}} must be a number",
      "wholeNumber": "{{label}} must be a whole number",
      "wholeInches": "{{label}} must be a whole number of inches",
      "outOfRange": "{{label}} must be between {{min}} and {{max}}",
      "invalidOption": "{{label}} has an invalid option",
      "invalidProject": "{{label}} has an invalid project",
      "invalidDate": "{{label}} is not a valid date",
      "invalidDateRange": "{{label}} is not a valid date range",
      "dateRangeOrder": "{{label}}: the start date must not be after the end date",
      "invalidUrl": "Please enter a valid URL",
      "invalidEmail": "Please enter a valid email",
      "tagsNotAllowed": "Creating new tags is not allowed",
      "invalidAmount": "Invalid amount",
      "negativeAmount": "The amount can’t be negative",
      "noDecimals": "{{currency}} amounts can’t have decimals",
      "tooManyDecimals_one": "The amount can have at most {{count}} decimal place",
      "tooManyDecimals_other": "The amount can have at most {{count}} decimal places",
      "billingUnit": "The billing unit must be daily, hourly or fixed",
      "invalidPercent": "{{label}}: enter a whole number from 0 to 100"
    },
    "readOnlyReason": {
      "noCapability": "You do not have permission to edit this field",
      "noCapabilityResource": "You do not have permission to edit this resource",
      "otherWorkspace": "Switch to this workspace to edit its values",
      "archivedWorkspace": "This workspace is archived",
      "displayOnly": "Read-only view",
      "lockedByType": "This field is locked by the resource type"
    },
    "badge": {
      "overriddenCount_one": "{{count}} field here has its own value instead of the Global one",
      "overriddenCount_other": "{{count}} fields here have their own values instead of the Global ones",
      "inherited": "Shows the Global value. Saving here gives this workspace its own.",
      "overridden": "This workspace has its own value; the Global one is not used here.",
      "newRow": "Added in this edit; saved with the list."
    },
    "partRequired": {
      "name": {
        "firstName": "Enter a first name.",
        "lastName": "Enter a last name."
      },
      "contactDetails": {
        "type": "Pick a type.",
        "value": "Enter a value."
      },
      "currency": {
        "currency": "Pick a currency."
      },
      "measurementLegacy": {
        "unit": "Pick a unit."
      },
      "tags": {
        "tagName": "Enter a tag name."
      },
      "groups": {
        "groupName": "Enter a group name."
      }
    },
    "jump": {
      "title": "Jump to field",
      "placeholder": "Find a field or a value…",
      "empty": "No field or value matches",
      "readOnly": "Read-only"
    }
  },
  "OverflowTabs": {
    "showMore": "Show {{count}} more",
    "pinned": "Shown here because it's selected"
  },
  "DiscussionThread": {
    "today": "Today",
    "yesterday": "Yesterday"
  }
}
